import axios from "axios";

//const
const VERIFY_ALGORITHM_LIST_STORE_DATA = "verifyAlgorithm/VERIFY_ALGORITHM_LIST_STORE_DATA";
const VERIFY_ALGORITHM_LIST_UPDATE_DATA = "verifyAlgorithm/VERIFY_ALGORITHM_LIST_UPDATE_DATA";
const VERIFY_ALGORITHM_LIST_UPDATE_PAGE_DATA = "verifyAlgorithm/VERIFY_ALGORITHM_LIST_UPDATE_PAGE_DATA";
const VERIFY_ALGORITHM_LIST_STORE_STATUSES_DATA = "verifyAlgorithm/VERIFY_ALGORITHM_LIST_STORE_STATUSES_DATA";

//reducer
export const verifyAlgorithm = (state = {
                                  showAlgorithms:[],
                                  algorithmStatuses:[],
                                  selectedStatus:"",
                                  selectedAlgorithm:"",
                                  inputName:"",
                                  page:0,
                                  size:10,
                                  total:0,
                                  testDoc:"",
                                  model: "python",
                                  inputUrl:"",
                                  inputType: "file",
                                  outputType: "hdfs",
                                  outputUrl: "result.data",
                                  num: "10",
                                  memory: "1G",
                                  cores: "1",
                                  resultTitle: [],
                                  resultData: [],
                                },action) => {
  switch (action.type) {
    case VERIFY_ALGORITHM_LIST_STORE_DATA:
      return {
        ...state,
        showAlgorithms:action.data.map(algorithm => {
          algorithm.key = algorithm.id;
          return algorithm;
        })
      };
    case VERIFY_ALGORITHM_LIST_STORE_STATUSES_DATA:
      return {
        ...state,
        algorithmStatuses:action.data,
      };
    case VERIFY_ALGORITHM_LIST_UPDATE_DATA:
      return {
        ...state,
        [action.data.name]: action.data.value
      };
    case VERIFY_ALGORITHM_LIST_UPDATE_PAGE_DATA:
      return {
        ...state,
        page:action.data.pageNumber,
        size:action.data.pageSize,
        total:action.data.totalElements
      };
    default:
      return state
  }
};

export const storeAlgorithms = (data) => {
  return {
    type: VERIFY_ALGORITHM_LIST_STORE_DATA,
    data:data
  }
};

export const storeAlgorithmStatuses = (data) => {
  return {
    type:VERIFY_ALGORITHM_LIST_STORE_STATUSES_DATA,
    data:data
  }
};

export const updateData = (data) => {
  return {
    type:VERIFY_ALGORITHM_LIST_UPDATE_DATA,
    data:data
  }
};

export const updatePageData = (data) => {
  return {
    type:VERIFY_ALGORITHM_LIST_UPDATE_PAGE_DATA,
    data:data
  }
};

export const getAlgorithmList = (data) => (dispatch) => {
  let url = "/api-algorithm/verifyingAlgorithmList?algorithmStatus="+data.status+"&algorithmName="+data.name+"&pageNumber="+data.page+"&pageSize="+data.size;
  axios.get(url, {contentType: "application/json"}).then(
    response =>{
      console.log(response.data.content);
      console.log(response.data.pageable.pageNumber);
      console.log(response.data.totalElements);
      dispatch(updatePageData({
        pageNumber:response.data.pageable.pageNumber,
        pageSize:response.data.pageable.pageSize,
        totalElements:response.data.totalElements
      }));
      dispatch(storeAlgorithms(response.data.content));

    }
  )
};

export const getAlgorithmStatuses = () => (dispatch) => {
  axios.get("/api-algorithm/algorithmStatuses", {contentType: "application/json"}).then(
    response =>{
      dispatch(storeAlgorithmStatuses(response.data._embedded.algorithmStatuses));
    }
  )
};

export const uploadFile = (data) => (dispatch) =>{
  if (data !== null && data !== ""){
    let headers = new Headers();
    headers.append("enctype", "multipart/form-data");
    let fileData = new FormData();
    fileData.append("File", data);
    axios({
      method: "post",
      headers: headers,
      mode: "cors",
      cache: "default",
      credentials: "include",
      url: "/api-datasetfiles/",
      data:fileData,
    }).then(
      response => {
        console.log(response.data)

      }
    )
  }
};
